import { getCitiesApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { CityResponse, Int64SimpleModel } from '@/core/generated/api';

/** Предоставляет операции со справочником городов */
export const cityService = {
    /** Загружает полный справочник городов */
    async getAll(): Promise<CityResponse[]> {
        try {
            const response = await getCitiesApi().getAllCities({});

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает город по числовому идентификатору */
    async getById(id: number): Promise<CityResponse> {
        try {
            const response = await getCitiesApi().getCityById({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Ищет города по запросу */
    async search(query: string): Promise<Int64SimpleModel[]> {
        try {
            const response = await getCitiesApi().searchCity({ search: query.trim() });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
